import CookiesJS from 'cookies-js';

export function initProgrammTasks($, apiClient) {
    $('form.programm-task-params-form .action__entity-save').on('click', async function () {
        try {
            const amount = parseInt($('#amount').val());
            const body = {
                notifyOnCreate: !!$('#notifyOnCreate').prop('checked'),
                notifyOnSuccess: !!$('#notifyOnSuccess').prop('checked'),
                notifyOnError: !!$('#notifyOnError').prop('checked'),
                sex: parseInt($('#sex').val()),
                deficit: parseInt($('#deficit').val()) || 0,
                height: parseInt($('#height').val()),
                weight: parseInt($('#weight').val()),
                age: parseInt($('#age').val()),
                meals: [
                    !!$('#meals0').prop('checked'),
                    !!$('#meals1').prop('checked'),
                    !!$('#meals2').prop('checked'),
                    !!$('#meals3').prop('checked'),
                    !!$('#meals4').prop('checked'),
                    !!$('#meals5').prop('checked')
                ],
                activityCoefficient: $('#activityCoefficient').val(),
                maxRecipeDifficulty: $('#maxRecipeDifficulty').val(),
                maxRecipePrice: $('#maxRecipePrice').val(),
                disallowedProducts: $('#disallowedProducts').val(),
                disallowedKitchenware: $('#disallowedKitchenware').val(),
                taskType: $('#taskType').val(),
                programmId: $('#programmId').val() || undefined,
            };
            const result = await apiClient.request({
                path: `/programm-tasks/user-params/${amount}`,
                method: 'post',
                body,
                token: CookiesJS.get('auth_token')
            });    
            console.log(result);
            document.location.href=`/programm-tasks/edit/${result.result._id}`;
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });

    $('form.programm-task-user-form .action__entity-save').on('click', async function () {
        try {
            const amount = parseInt($('#amount').val());
            const deficit = parseInt($('#deficit').val()) || 0;
            const userId = $('#userId').val();
            const result = await apiClient.request({
                path: `/programm-tasks/user/${userId}/${amount}`,
                body: {
                    notifyOnCreate: !!$('#notifyOnCreate').prop('checked'),
                    notifyOnSuccess: !!$('#notifyOnSuccess').prop('checked'),
                    notifyOnError: !!$('#notifyOnError').prop('checked'),
                    deficit,
                    taskType: $('#taskType').val(),
                    programmId: $('#programmId').val() || undefined,
                },
                method: 'post',
                token: CookiesJS.get('auth_token')
            });
            console.log(result);
            document.location.href=`/programm-tasks/edit/${result.result._id}`;
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
